import { render } from "./ModalStudyTask.vue?vue&type=template&id=3bf46899"
import script from "./ModalStudyTask.vue?vue&type=script&lang=js"
export * from "./ModalStudyTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__